// modules/Battle/BattleUIMessage.js
// 战斗UI消息显示模块

export default class BattleUIMessage {
    constructor(scene, layout) {
        this.scene = scene;
        this.layout = layout;
        this.currentScrollTimer = null;
        this.scrollLines = [];
        this.currentScrollIndex = 0;
    }
    
    /**
     * 显示消息
     * @param {string} message - 消息文本
     */
    showMessage(message) {
        const messages = this.layout.getMessageElements();
        if (messages && messages.text) {
            messages.text.setText(message);
        }
    }
    
    /**
     * 逐行滚动显示消息（带动画效果）
     * @param {string} message - 消息文本（多行，用\n分隔）
     * @param {number} delayPerLine - 每行显示的延迟（毫秒），默认300
     * @param {Function} onComplete - 完成回调
     */
    showMessageScrolling(message, delayPerLine = 300, onComplete = null) {
        // 清除之前的滚动
        this.clearScroll();
        
        // 按行分割消息（保留空行作为分隔）
        const lines = message.split('\n');
        if (lines.length === 0) {
            if (onComplete) onComplete();
            return;
        }
        
        this.scrollLines = lines;
        this.currentScrollIndex = 0;
        
        const messages = this.layout.getMessageElements();
        if (!messages || !messages.text) {
            if (onComplete) onComplete();
            return;
        }
        
        // 确保文本可见
        messages.text.setAlpha(1);
        // 清空当前文本
        messages.text.setText('');
        
        // 逐行显示
        const showNextLine = () => {
            if (this.currentScrollIndex >= this.scrollLines.length) {
                // 所有行都显示完毕
                if (onComplete) onComplete();
                return;
            }
            
            // 获取当前已显示的文本
            const currentText = messages.text.text;
            const lineToAdd = this.scrollLines[this.currentScrollIndex];
            
            // 添加新行（即使是空行也添加，用于保持格式）
            const newText = currentText === '' 
                ? lineToAdd
                : currentText + '\n' + lineToAdd;
            
            // 设置新文本
            messages.text.setText(newText);
            
            // 为文本添加轻微的淡入效果（如果行不为空）
            if (lineToAdd.trim() !== '') {
                // 先设置为半透明
                messages.text.setAlpha(0.3);
                // 然后淡入到完全不透明
                this.scene.tweens.add({
                    targets: messages.text,
                    alpha: 1,
                    duration: 150,
                    ease: 'Power1'
                });
            }
            
            this.currentScrollIndex++;
            
            // 继续显示下一行
            if (this.currentScrollIndex < this.scrollLines.length) {
                this.currentScrollTimer = this.scene.time.delayedCall(delayPerLine, showNextLine);
            } else {
                // 所有行显示完毕
                // 确保文本完全可见
                messages.text.setAlpha(1);
                if (onComplete) onComplete();
            }
        };
        
        // 开始显示第一行
        showNextLine();
    }
    
    /**
     * 清除当前的滚动显示
     */
    clearScroll() {
        if (this.currentScrollTimer) {
            this.currentScrollTimer.destroy();
            this.currentScrollTimer = null;
        }
        this.scrollLines = [];
        this.currentScrollIndex = 0;
    }
    
    /**
     * 显示玩家回合消息
     */
    showPlayerTurn() {
        this.clearScroll();
        this.showMessage('选择你的行动');
    }
    
    /**
     * 显示敌人回合消息
     */
    showEnemyTurn() {
        this.clearScroll();
        this.showMessage('敌人回合');
    }
    
    /**
     * 显示胜利消息
     */
    showVictory() {
        this.clearScroll();
        this.showMessage('战斗胜利！');
    }
    
    /**
     * 显示失败消息
     */
    showDefeat() {
        this.clearScroll();
        this.showMessage('战斗失败！');
    }
}

